import Map from 'ol/Map.js';
import View from 'ol/View.js';

import OSM from 'ol/source/OSM.js';
import TileLayer from 'ol/layer/Tile.js';
import { Attribution, defaults as defaultControls } from 'ol/control.js';

import GeoJSON from 'ol/format/GeoJSON.js';
import VectorLayer from 'ol/layer/Vector.js';
import VectorSource from 'ol/source/Vector.js';
import { Circle, Fill, Stroke, Style, Text } from 'ol/style.js';
import { fromLonLat } from 'ol/proj.js';


// -------------------------------------------------------------------
// Styles settings
// -------------------------------------------------------------------
const styles = {};
const white = [255, 255, 255, 1];
const blue = [0, 153, 255, 1];
const width = 3;

styles['Point'] = [
  new Style({
    image: new Circle({
      radius: width * 6,
      fill: new Fill({
        color: white,
      }),
      stroke: new Stroke({
        color: blue,
        width: width / 6,
      }),
    }),
    text: new Text({
      font: 'bold 48px "Open Sans", "Arial Unicode MS", "sans-serif"',
      placement: 'point',
      overflow: true,
      fill: new Fill({color: '#00f'}),
      stroke: new Stroke({color: '#fff', width: 4}),
    }),
    zIndex: Infinity,
  }),
];


// -------------------------------------------------------------------
// White Map
// -------------------------------------------------------------------
// const map = new Map({
// target: 'map',
// view: new View({
// center: fromLonLat([-100, 38.5]),
// zoom: 4,
// }),
// });

// -------------------------------------------------------------------
// General OSM Layer with attributions
// -------------------------------------------------------------------


const attribution = new Attribution({
  collapsible: false,
});

const map = new Map({
  layers: [
    new TileLayer({
      source: new OSM(),
    }),
  ],
  controls: defaultControls({ attribution: false }).extend([attribution]),
  target: 'map',
  view: new View({
    center: fromLonLat([8.66667,47.36580]),
    zoom: 10,
  }),
});

function checkSize() {
  const small = map.getSize()[0] < 600;
  attribution.setCollapsible(small);
  attribution.setCollapsed(small);
}


// -------------------------------------------------------------------
// Vector Layer 
// -------------------------------------------------------------------
const style = [ styles['Point'][0] ];

const vectorLayer = new VectorLayer({
  // background: 'white',
  source: new VectorSource({
    // url: 'live-data/us-states.json',
    // url: 'live-data/locations.json',
    url: 'live-data/sensecap-geojson-location.json',
	
    format: new GeoJSON(),
  }),
  style: function (feature) {
    const label = feature.get('name').split(' ').join('\n');
    styles['Point'][0].getText().setText(label);
    return style;
  },
  declutter: true,
});

map.addLayer(vectorLayer);

// -------------------------------------------------------------------
// size
// -------------------------------------------------------------------
map.on('change:size', checkSize);
checkSize();
